import { render, staticRenderFns } from "./TogglesItem.vue?vue&type=template&id=408a3ec4&"
import script from "./TogglesItem.vue?vue&type=script&lang=js&"
export * from "./TogglesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TogglesItem.vue"
export default component.exports